import script from "./CompanyCreateUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyCreateUpdate.vue?vue&type=script&setup=true&lang=js"

import "./CompanyCreateUpdate.vue?vue&type=style&index=0&id=22492c58&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22492c58"]])

export default __exports__